export default {
  // 大写
  INITMUSICMES(state, value) {
    state.musicMes = value
  },
  UPDATE_CURRENT_LANG(state, currentLang) {
    state.currentLang = currentLang
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js